// src/sectors/pilates/sessions/components/calendar/MobileDayList/mobileDayList.utils.js

/* ---------------- existing ---------------- */
export function sortByTime(a, b) {
  const am = Number(a?.startMin ?? 0);
  const bm = Number(a?.startMin ?? 0);
  if (am !== bm) return am - bm;
  return Number(a?.id ?? 0) - Number(b?.id ?? 0);
}

const pad2 = (n) => String(n).padStart(2, '0');
export const hm = (min) =>
  `${pad2(Math.floor((Number(min) || 0) / 60))}:${pad2((Number(min) || 0) % 60)}`;

// byDaySlot Map değilse (object) fallback
export const getByDaySlot = (byDaySlot, key) => {
  if (!byDaySlot) return [];
  if (typeof byDaySlot.get === 'function') return byDaySlot.get(key) || [];
  return byDaySlot[key] || [];
};

export function buildDaySessions({ day, slots, byDaySlot }) {
  const out = [];
  (slots || []).forEach((m) => {
    const list = getByDaySlot(byDaySlot, `${day}|${Number(m)}`);
    list.forEach((x) => out.push(x));
  });
  out.sort(sortByTime);
  return out;
}

/* ---------------- NEW: date helpers (ISO, week) ---------------- */

// ISO: "2026-01-19"
const isoToDateLocal = (iso) => {
  const s = String(iso || '').slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  // local date (timezone safe for calendar usage)
  return new Date(y, m - 1, d);
};

const dateToISO = (dt) => {
  if (!(dt instanceof Date) || Number.isNaN(dt.getTime())) return '';
  return `${dt.getFullYear()}-${pad2(dt.getMonth() + 1)}-${pad2(dt.getDate())}`;
};

const addDays = (iso, days) => {
  const dt = isoToDateLocal(iso);
  if (!dt) return '';
  dt.setDate(dt.getDate() + Number(days || 0));
  return dateToISO(dt);
};

// Pazartesi başlangıç (TR’de genelde böyle)
export function startOfWeekISO(iso, weekStartsOn = 1) {
  const dt = isoToDateLocal(iso);
  if (!dt) return '';

  // JS: 0=Pazar ... 6=Cumartesi
  const dow = dt.getDay();
  // weekStartsOn: 1=Monday
  const diff = (dow - weekStartsOn + 7) % 7;

  dt.setDate(dt.getDate() - diff);
  return dateToISO(dt);
}

export function weekDaysFromWeekStart(weekStartISO) {
  const start = String(weekStartISO || '').slice(0, 10);
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
}

const TR_DAY_LABELS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

export function trDayLabelFromISO(iso) {
  const dt = isoToDateLocal(iso);
  if (!dt) return '';
  return TR_DAY_LABELS[dt.getDay()] || '';
}
// ISO: "2026-01-19" + N gün => "2026-01-26"
export function addDaysISO(iso, days) {
  const s = String(iso || '').slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return '';

  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + Number(days || 0));

  const pad2 = (n) => String(n).padStart(2, '0');
  return `${dt.getFullYear()}-${pad2(dt.getMonth() + 1)}-${pad2(dt.getDate())}`;
}

const TR_DAY_SHORT = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];

// "2026-01-19" => "Pzt"
export function trDayShortFromISO(iso) {
  const s = String(iso || '').slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return '';

  const dt = new Date(y, m - 1, d);
  return TR_DAY_SHORT[dt.getDay()] || '';
}
